var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.946,
    height: 28.976,
    viewBox: "0 0 31.946 28.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.051,8.416H16.138a1.118,1.118,0,0,1,0-2.236h8.913a1.118,1.118,0,1,1,0,2.236Z",
    transform: "translate(5.777 -0.989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.06,8.416H3.118a1.118,1.118,0,1,1,0-2.236H9.06a1.118,1.118,0,0,1,0,2.236Z",
    transform: "translate(-2 -0.989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.5,15.548A6.309,6.309,0,1,0,6.19,9.239,6.309,6.309,0,0,0,12.5,15.548Z",
    transform: "translate(0.502 -2.93)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.94,18.646H18a1.118,1.118,0,1,1,0-2.236H23.94a1.118,1.118,0,1,1,0,2.236Z",
    transform: "translate(6.887 5.123)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.031,18.646H3.118a1.118,1.118,0,1,1,0-2.236h8.913a1.118,1.118,0,1,1,0,2.236Z",
    transform: "translate(-2 5.123)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.219,25.788A6.309,6.309,0,1,0,9.91,19.479,6.309,6.309,0,0,0,16.219,25.788Z",
    transform: "translate(2.725 3.187)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.58b76304.svg";
export { ForwardRef as ReactComponent };